<template>
  <div class="wrp">
    <div class="top-tit">Revenue</div>
    <h1 class="clear">
      <span class="active" @click="linkTo('current')" id="revenue-history">Revenue History</span>
      <span v-if="isRevenueTargetForecastActivated" @click="linkTo('/revenue-forcasting')" id="revenue-forecasting">Revenue Forecasting</span>
      <span @click="linkTo('/income')" v-if="doshiiFlag">Doshii Area</span>
      <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || squareFlag || swiftPosFlag || oolioFlag) && isPro" @click="linkTo('/product-categories')" id="product">Product
        Categories</span>
      <span v-if="(oseriesFlag || squareFlag) && isPro" @click="linkTo('/terminals')">Terminals</span>
      <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || squareFlag || swiftPosFlag || oolioFlag) && isPro" @click="linkTo('/revenue-group')" id="revenue-group">Revenue
        Group</span>
      <span v-if="!squareFlag && !swiftPosFlag" @click="linkTo('/accounting-categories')">Accounting Categories </span>

      <!-- <button v-if="isPro" @click="openUpload">Import Excel</button> -->
    </h1>
    <div class="revenue table-wrp">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="left" label="Week Ending" width="180">
          <template slot-scope="scope">
            <div class="table-header-title">{{scope.row.left}} <el-tag v-if="scope.row.left == 'Average Revenue'" size="small">{{isGstAdded ? 'Inc-GST' : 'Ex-GST' }}</el-tag></div>
          </template>
        </el-table-column>
        <el-table-column label="Mon">
          <template slot-scope="scope">
            <div>{{ scope.row.mon }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Tues">
          <template slot-scope="scope">
            <div>{{ scope.row.tue }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Wed">
          <template slot-scope="scope">
            <div>{{ scope.row.wed }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Thu">
          <template slot-scope="scope">
            <div>{{ scope.row.thu }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Fri">
          <template slot-scope="scope">
            <div>{{ scope.row.fri }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Sat">
          <template slot-scope="scope">
            <div>{{ scope.row.sat }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Sun">
          <template slot-scope="scope">
            <div>{{ scope.row.sun }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">
            <div>{{ scope.row.total }} <span v-if="scope.row.left === 'Percentage'">%</span></div>
          </template>
        </el-table-column>
        <template slot="empty">
          <i v-if="loading1" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
    </div>

    <div class="revenue-more table-wrp">
        <el-table
            :data="tableData2"
            border
            style="width: 100%">
          <el-table-column
              prop="cycle"
              label="Week Ending">
          </el-table-column>
          <el-table-column
              label="Mon">
              <template slot-scope="scope">
                  <div :class="scope.row.monIsAvgCost === true ? 'red' : ''">{{scope.row.mon ? `$${scope.row.mon}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Tues">
              <template slot-scope="scope">
                  <div :class="scope.row.tueIsAvgCost === true ? 'red' : ''">{{scope.row.tue ? `$${scope.row.tue}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Wed">
              <template slot-scope="scope">
                  <div :class="scope.row.wedIsAvgCost === true ? 'red' : ''">{{scope.row.wed ? `$${scope.row.wed}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Thu">
              <template slot-scope="scope">
                  <div :class="scope.row.thuIsAvgCost === true ? 'red' : ''">{{scope.row.thu ? `$${scope.row.thu}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Fri">
              <template slot-scope="scope">
                  <div :class="scope.row.friIsAvgCost === true ? 'red' : ''">{{scope.row.fri ? `$${scope.row.fri}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Sat">
              <template slot-scope="scope">
                  <div :class="scope.row.satIsAvgCost === true ? 'red' : ''">{{scope.row.sat ? `$${scope.row.sat}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Sun">
              <template slot-scope="scope">
                  <div :class="scope.row.sunIsAvgCost === true ? 'red' : ''">{{scope.row.sun ? `$${scope.row.sun}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              label="Total">
              <template slot-scope="scope">
                  <div>{{scope.row.total ? `$${scope.row.total}` : '-'}}</div>
              </template>
          </el-table-column>
          <el-table-column
              v-if="hasLastWeekData"
              label="Operating"
              width="100">
              <template slot-scope="scope">
                  <div class="icon" @click="operate(scope.row.id, scope.$index, scope.row)"></div>
              </template>
          </el-table-column>
          <template slot="empty">
            <i v-if="loading2" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
      </el-table>
      <!--<pageination :total="totalRecord" :size="pagesize" @togglePage="pageChange"></pageination>-->
    </div>

    <template>
      <transition name="fade" v-if="showupload">
        <div class="pop-wrp">
          <div class="second-step" v-if="over === false">
            <h1>Import Excel</h1>
            <div class="upload-con" v-if="!uploaded">
              <i class="icon" v-if="!uploading"></i>
              <h3 v-if="!uploading">Drag the file here, or <span>Click to upload</span><br />Only Excel files can be uploaded</h3>
              <el-upload
                v-if="!uploading"
                class="upload-demo"
                drag
                action=""
                :multiple="false"
                :http-request="excelUpload"
                :show-file-list="false">
              </el-upload>
              <i class="el-icon-loading" v-if="uploading"></i>
            </div>
             <div class="upload-con" v-if="uploaded">
              <div class="file">
                <div class="in"></div>
                <div class="text">
                  <div class="tit">{{name}}</div>
                  <div class="size">{{size}}k</div>
                </div>
              </div>
              <div class="close" @click="remove"></div>
            </div>
            <div class="btns clear">
              <button class="dark" @click="closeUpload">Back</button>
              <button class="light" :disabled="uploaddisable" :class="{'usable': !uploaddisable}" @click="toUpload">Confirm</button>
            </div>
          </div>
          <div class="upload-success" v-if="over === true">
            <i></i>
            <h4>Import succeeded!</h4>
            <button class="light usable" @click="closeUpload">Confirm</button>
          </div>
        </div>
      </transition>
    </template>


    <!-- 弹窗 -->
    <transition name="fade" v-if="showedit">
      <div class="pop-wrp">
        <div class="lst">
          <div class="box">
            <h1 style="margin-bottom:50px;text-align:center;">Edit</h1>
            <div class="table-wrp">
              <el-table :data="tableData3" border style="width: 100%">
                <el-table-column prop="cycle">
                </el-table-column>
                <el-table-column label="Mon">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Mon</h3>
                      <h4>{{ getDateInString('mon') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.mon" @input="validate('mon')" />
                  </template>
                </el-table-column>
                <el-table-column label="Tues">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Tue</h3>
                      <h4>{{ getDateInString('tue') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.tue" @input="validate('tue')" />
                  </template>
                </el-table-column>
                <el-table-column label="Wed">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Wed</h3>
                      <h4>{{ getDateInString('wed') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.wed" @input="validate('wed')" />
                  </template>
                </el-table-column>
                <el-table-column label="Thu">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Thu</h3>
                      <h4>{{ getDateInString('thu') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.thu" @input="validate('thu')" />
                  </template>
                </el-table-column>
                <el-table-column label="Fri">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Fri</h3>
                      <h4>{{ getDateInString('fri') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.fri" @input="validate('fri')" />
                  </template>
                </el-table-column>
                <el-table-column label="Sat">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Sat</h3>
                      <h4>{{ getDateInString('sat') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.sat" @input="validate('sat')" />
                  </template>
                </el-table-column>
                <el-table-column label="Sun">
                  <template slot="header" slot-scope="scope">
                    <div class="table-head-week">
                      <h3>Sun</h3>
                      <h4>{{ getDateInString('sun') }}</h4>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <input type="text" v-model="scope.row.sun" @input="validate('sun')" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="btns clear">
              <button class="dark" @click="close('cancel')">Cancel</button>
              <button class="light" @click="close('confirm')" :disabled="editdisable"
                :class="{ 'usable': !editdisable }">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 弹窗 -->

    <transition name="fade" v-if="showconfirm">
      <div class="pop-wrp">
        <div class="pop-confirm">
          <h1 style="padding-top: 50px;margin-bottom: 65px;text-align:center">Data already exists on part of the date.
            Do
            you want to overwrite it?</h1>
          <div class="triple">
            <button @click="closeconfirm('cancel')">Cancel</button>
            <button @click="closeconfirm('over')">Overwrite Data</button>
            <button @click="closeconfirm('keep')">Keep Original Data</button>
          </div>
        </div>
      </div>
    </transition>

    <el-dialog title="" :visible.sync="enterActualIncomeShow" :modal-append-to-body="false" :show-close="false"
      class="delEmployDio pad-rgt-0 customize-dialog" :close-on-click-modal="false" width="1300px" center>
      <TreeTable title="Daily Revenue & Expenses" :weekStart="1" :currentWeek="currentWeek" :hasLabour="hasLabour"
        text="Please enter the actual sales, we will subtract the commission to calculate the net revenue."
        :loading="loading3" :list="tableData4" @cancel="enterActualIncomeShow = false" @confirm="confirmUpdate"
        :requesting="tableConfirming" />
    </el-dialog>

    <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro"
        @close-notice="closeOrLogoutVenue"></free-trial-notice>
    </el-dialog>

  </div>
</template>

<script>
import api from '../../api/revenue'
import http from '../../api/dashboard'
import pageination from '../../components/common/pageination'
import treeTable from "../../components/dashboard/component/treeTable.vue";
import freeTrialNotice from '@/components/modal/freeTrialNotice';

export default {
  name: 'headcon',
  inject: ['reload', 'hidden', 'show2'],
  data() {
    return {
      hasLabour: true,

      doshiiFlag: false,
      isGstAdded: false,
      tableConfirming: false,
      tableData: [],
      tableData2: [],
      tableData3: [],
      uploaddisable: true,
      showupload: false,
      uploading: false,
      uploaded: false,
      showconfirm: false,
      temp: null,
      showedit: false,
      editdisable: false,
      loading1: true, // 表格1正在加载
      loading2: true, // 表格2正在加载
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      id: null, // 当前操作id
      index: null, // 当前操作的索引
      tempFormdata: null,
      over: false,
      name: null,
      size: null,
      // 2021/12/30
      enterActualIncomeShow: false,
      tableData4: [],
      loading3: false,
      loadingEnterActual: false,
      dataHght: '',
      currentWeek: [],

      hasLastWeekData: false,

      currentId: null,
      isPro: false,
      isRevenueTargetForecastActivated: false,
      squareFlag: false,
      oseriesFlag: false,
      tevalisFlag: false,
      redcatFlag: false,
      swiftPosFlag: false,
      venueDiscountDetailsPojo: null,
      isTrialEnd: false,
      prevWeek: [],
      isDisable: false,
    }
  },
  created() {
    // 上方表格
    api.average({ callback: this.topCallback })
    // 下方表格
    api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })

    api.progress({
      callback: (res) => {
        if (res.data.code === 0 && res.data.data.doshiiFlag) {
          this.doshiiFlag = true
        }

        if (res.data.code === 0 && res.data.data.oseriesFlag) {
          this.oseriesFlag = true;
        }

        if (res.data.code === 0 && res.data.data.tevalisFlag) {
          this.tevalisFlag = true;
        }

        if (res.data.code === 0 && res.data.data.redcatFlag) {
          this.redcatFlag = true;
        }

        if (res.data.code === 0 && res.data.data.oolioFlag) {
          this.oolioFlag = true;
        }

        if (res.data.code === 0 && res.data.data.squareFlag) {
          this.squareFlag = true
        }

        if (res.data.code === 0 && res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true;
        }

        if (res.data.code === 0) {
          this.isGstAdded = res.data.data.isGstAdded ? true : false;
        }

      }
    })

    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro
      this.isRevenueTargetForecastActivated = others.isRevenueTargetForecastActivated


      const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
      if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
        this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
        this.isTrialEnd = true
      }
    })
  },
  methods: {
    getDateInString(dayName) {
      const date = this.prevWeek.find(item => item.day === dayName)
      return date ? date.time : '';
    },
    linkTo(path) {
      if (path === 'current') {
        this.reload()
      } else {
        this.$router.push(path)
      }
    },
    confirmUpdate(params) {
      if (this.tableConfirming)
        return
      this.tableConfirming = true
      http.updateActualIncome({
        params: params,
        callback: this.actualUpdateCallback,
      });
    },
    // 2021/12/30
    enterActualIncome(start, end) {
      let _params = {
        incomeType: 0,
        monDateTime: start,
        sunDateTime: end
      }
      this.currentWeek = this.$box.loadWeekDatum(_params.monDateTime)

      // this.currentWeek = this.$box.loadWeekDatum(_params.monDateTime * 1000)

      this.enterActualIncomeShow = true
      this.tableData4 = []
      this.loading3 = true

      http.getActualIncome({
        params: _params,
        callback: this.actualIncomeCallback
      })
      // this.hidden()
    },
    actualUpdateCallback(res) {
      var that = this
      that.tableConfirming = false
      this.loadingEnterActual = false
      if (res.data.code == 0) {
        this.enterActualIncomeShow = false
        this.show2()
        this.tableData2 = []
        this.loading2 = true
        // 下方表格
        api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    actualIncomeCallback(res) {
      var that = this
      that.loading3 = false
      that.hasLabour = false
      if (res.data.code == 0) {
        let data = res.data.data
        // 11.15
        let tableDatum = [
          {
            left: 'Total',
            mon: data.total.mon,
            tues: data.total.tue,
            wed: data.total.wed,
            thu: data.total.thu,
            fri: data.total.fri,
            sat: data.total.sat,
            sun: data.total.sun,
            shrink: false,
            color: 'green',
            son: []
          }
        ]
        if (data.list && data.list[0]) {
          data.list.forEach((item) => {
            let temp = []
            if (item.actualIncomeList && item.actualIncomeList[0]) {
              item.actualIncomeList.forEach(i => {
                temp.push({
                  shrink: false,
                  parentRevenue: i.parentRevenue ? i.parentRevenue : null,
                  left: i.incomeName,
                  mon: i.mon,
                  tues: i.tue,
                  wed: i.wed,
                  thu: i.thu,
                  fri: i.fri,
                  sat: i.sat,
                  sun: i.sun,

                  editmon: false,
                  edittues: false,
                  editwed: false,
                  editthu: false,
                  editfri: false,
                  editsat: false,
                  editsun: false,

                  withDollar: item.expensesType !== 3 ? true : false,
                  color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''),

                  monDateTime: i.monDateTime,
                  sunDateTime: i.sunDateTime,
                  revenueType: i.revenueType,
                  incomeType: i.incomeType,
                  id: i.id,
                  incomeId: i.incomeId,

                  expensesType: item.expensesType,
                  incomeCommission: i.incomeCommission,
                  ofDoshii: !i.revenueFrom ? false : true
                })
              })
            }
            if (item.expensesType === 4) {
              that.hasLabour = true
              tableDatum[0].son.push({
                left: 'Labour',
                mon: temp[0].mon,
                tues: temp[0].tues,
                wed: temp[0].wed,
                thu: temp[0].thu,
                fri: temp[0].fri,
                sat: temp[0].sat,
                sun: temp[0].sun,
                shrink: false,
                color: 'white',
                son: [],
                hideArrow: true,

                monDateTime: temp[0].monDateTime,
                sunDateTime: temp[0].sunDateTime,
                revenueType: temp[0].revenueType,
                incomeType: temp[0].incomeType,
                id: temp[0].id,
                incomeId: temp[0].incomeId,

                expensesType: item.expensesType,
                incomeCommission: temp[0].incomeCommission,
                editmon: false,
                edittues: false,
                editwed: false,
                editthu: false,
                editfri: false,
                editsat: false,
                editsun: false,
                ofDoshii: temp[0].ofDoshii
              })
            } else
              tableDatum[0].son.push({
                left: item.expensesType === 1 ? 'Revenue' : (item.expensesType === 2 ? 'Delivery' : (item.expensesType === 3 ? 'Expenses' : '')),
                mon: item.total.mon,
                tues: item.total.tue,
                wed: item.total.wed,
                thu: item.total.thu,
                fri: item.total.fri,
                sat: item.total.sat,
                sun: item.total.sun,
                shrink: false,
                color: item.expensesType !== 3 ? 'green' : 'pink',
                son: temp,
                expensesType: item.expensesType,
              })
          })
          that.tableData4 = tableDatum
        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 2021/12/30
    getLocalTime(i, timeVal) {
      //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return;
      var d = new Date(timeVal);
      //得到1970年一月一日到现在的秒数
      var len = timeVal;
      //本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000;
      //得到现在的格林尼治时间
      var utcTime = len + offset;
      // 返回指定时间的时间戳
      return utcTime + 3600000 * i;
    },
    operate(id, index, row2) {

      this.prevWeek = this.$box.loadWeekDatum(row2.monDateTime)

      if (index === 0 && this.hasLastWeekData === true) {
        this.enterActualIncome(row2.monDateTime, row2.sunDateTime)
        this.currentId = id
        return
      }
      this.id = null
      this.index = null
      this.tableData3 = []
      this.editdisable = false
      this.showedit = true

      const row = {}
      row.cycle = this.tableData2[index].cycle
      let mon = this.tableData2[index].mon
      let fri = this.tableData2[index].fri
      let sat = this.tableData2[index].sat
      let thu = this.tableData2[index].thu
      let sun = this.tableData2[index].sun
      let tue = this.tableData2[index].tue
      let wed = this.tableData2[index].wed
      if (this.tableData2[index].mon && this.tableData2[index].mon.indexOf(',') !== -1) {
        mon = this.tableData2[index].mon.split(',')
        mon = mon.join('')
      }
      if (this.tableData2[index].fri && this.tableData2[index].fri.indexOf(',') !== -1) {
        fri = this.tableData2[index].fri.split(',')
        fri = fri.join('')
      }
      if (this.tableData2[index].sat && this.tableData2[index].sat.indexOf(',') !== -1) {
        sat = this.tableData2[index].sat.split(',')
        sat = sat.join('')
      }
      if (this.tableData2[index].thu && this.tableData2[index].thu.indexOf(',') !== -1) {
        thu = this.tableData2[index].thu.split(',')
        thu = thu.join('')
      }
      if (this.tableData2[index].sun && this.tableData2[index].sun.indexOf(',') !== -1) {
        sun = this.tableData2[index].sun.split(',')
        sun = sun.join('')
      }
      if (this.tableData2[index].tue && this.tableData2[index].tue.indexOf(',') !== -1) {
        tue = this.tableData2[index].tue.split(',')
        tue = tue.join('')
      }
      if (this.tableData2[index].wed && this.tableData2[index].wed.indexOf(',') !== -1) {
        wed = this.tableData2[index].wed.split(',')
        wed = wed.join('')
      }
      row.mon = mon ? ('$' + mon) : ''
      row.fri = fri ? ('$' + fri) : ''
      row.sat = sat ? ('$' + sat) : ''
      row.thu = thu ? ('$' + thu) : ''
      row.sun = sun ? ('$' + sun) : ''
      row.tue = tue ? ('$' + tue) : ''
      row.wed = wed ? ('$' + wed) : ''
      this.tableData3.push(row)
      this.id = id
      this.index = index
    },
    close(type) {
      if (type === 'confirm') {
        this.tableData3[0].id = this.id

        if (this.tableData3[0].mon === '$') {
          this.tableData3[0].mon = '$0'
        }
        if (this.tableData3[0].fri === '$') {
          this.tableData3[0].fri = '$0'
        }
        if (this.tableData3[0].sat === '$') {
          this.tableData3[0].sat = '$0'
        }
        if (this.tableData3[0].thu === '$') {
          this.tableData3[0].thu = '$0'
        }
        if (this.tableData3[0].sun === '$') {
          this.tableData3[0].sun = '$0'
        }
        if (this.tableData3[0].tue === '$') {
          this.tableData3[0].tue = '$0'
        }
        if (this.tableData3[0].wed === '$') {
          this.tableData3[0].wed = '$0'
        }

        this.tableData3[0].mon = parseFloat(this.tableData3[0].mon.split('$')[1]).toFixed(2)
        this.tableData3[0].fri = parseFloat(this.tableData3[0].fri.split('$')[1]).toFixed(2)
        this.tableData3[0].sat = parseFloat(this.tableData3[0].sat.split('$')[1]).toFixed(2)
        this.tableData3[0].thu = parseFloat(this.tableData3[0].thu.split('$')[1]).toFixed(2)
        this.tableData3[0].sun = parseFloat(this.tableData3[0].sun.split('$')[1]).toFixed(2)
        this.tableData3[0].tue = parseFloat(this.tableData3[0].tue.split('$')[1]).toFixed(2)
        this.tableData3[0].wed = parseFloat(this.tableData3[0].wed.split('$')[1]).toFixed(2)

        let data = this.tableData3[0]
        data.id = this.id
        // 修改记录
        this.editdisable = true
        api.update({
          params: data,
          callback: this.updateCallback
        })
      } else {
        this.showedit = false
      }
    },
    updateCallback(res) {
      var that = this
      if (res.data.code == 0) {
        that.loading2 = true
        that.tableData2 = []
        that.loading = true
        that.tableData = []
        // 下方表格
        api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })
        // 上方表格
        api.average({ callback: this.topCallback })
        /* that.tableData3[0].total = parseFloat(that.tableData3[0].fri) +
          parseFloat(that.tableData3[0].mon) +
          parseFloat(that.tableData3[0].sat) +
          parseFloat(that.tableData3[0].sun) +
          parseFloat(that.tableData3[0].thu) +
          parseFloat(that.tableData3[0].tue) +
          parseFloat(that.tableData3[0].wed)
        that.tableData3[0].total = that.tableData3[0].total.toFixed(2)

        that.tableData2[that.index] = that.tableData3[0]
        // this.$set(that.tableData2,that.index,that.tableData3[0])
        that.$forceUpdate()
        const temp = JSON.stringify(that.tableData2)
        that.tableData2 = []
        that.tableData2 = JSON.parse(temp) */
        that.showedit = false
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    closeUpload() {
      this.showupload = false
      this.uploaded = false
      this.over = false
      this.name = null
      this.size = null
      this.uploaddisable = true
      this.tempFormdata = null
      this.temp = null
    },
    openUpload() {
      this.showupload = true
      this.uploaddisable = true
      this.name = null
      this.size = null
      this.uploaddisable = true
      this.tempFormdata = null
      this.temp = null
    },
    remove() {
      this.uploaded = false
      this.name = null
      this.size = null
      this.uploaddisable = true
    },
    excelUpload(e) {
      var that = this
      // 获取文件大小
      /* const size = e.file.size
      if (size > 5242880) {
        this.$message({
          type: 'error',
          message: 'File is too large'
        })
        return
      } */
      const name = e.file.name.split('.')
      const type = name[name.length - 1]
      if (type !== 'csv') {
        Utils.alert('', 'Please upload the.cvs file', 'error')
        return
      }
      // 在这里调接口
      that.name = e.file.name
      that.size = (e.file.size / 1024).toFixed(1)
      var formData = new FormData()
      formData.append("file", e.file)
      that.tempFormdata = formData
      that.uploaded = true
      that.uploaddisable = false
    },
    toUpload() {
      var that = this
      that.uploading = true
      that.uploaded = false
      api.upload({
        params: that.tempFormdata,
        type: 1,
        callback: that.uploadCallback
      })
    },
    uploadCallback(res) {
      var that = this
      that.uploading = false
      that.showupload = true
      that.uploaded = true
      if (res.data.code == 0) {
        // Utils.alert('', 'Import Success', 'success')
        that.seconddisable = false
        that.tableData = []
        that.tableData2 = []
        that.loading1 = true
        that.loading2 = true
        that.totalRecord = 0
        // 上方表格
        api.average({ callback: this.topCallback })
        // 下方表格
        api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })
        this.over = true
      } else if (res.data.code === 10002) {
        that.showconfirm = true
        that.temp = res.data.data
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    closeconfirm(type) {
      if (type === 'cancel') {
        this.showconfirm = false
        this.name = null
        this.size = null
        this.uploaddisable = true
        this.tempFormdata = null
        this.temp = null
      } else if (type === 'over') {
        Utils.loadings()
        api.over({
          params: {
            map: this.temp,
            overwriteFlag: true,
            uploadType: 1
          },
          callback: this.closeCallback
        })
      } else if (type === 'keep') {
        Utils.loadings()
        api.over({
          params: {
            map: this.temp,
            overwriteFlag: false,
            uploadType: 1
          },
          callback: this.closeCallback
        })
      }
    },
    closeCallback(res) {
      var that = this
      Utils.loadings(2)
      this.uploaded = false
      this.name = null
      this.size = null
      this.uploaddisable = true
      this.showupload = false
      if (res.data.code == 0) {
        that.showconfirm = false
        that.tableData = []
        that.tableData2 = []
        that.loading1 = true
        that.loading2 = true
        that.totalRecord = 0
        // 上方表格
        api.average({ callback: this.topCallback })
        // 下方表格
        api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    topCallback(res) {
      var that = this
      that.loading1 = false
      if (res.data.code == 0) {
        // 等待接口
        that.tableData.push({
          left: 'Percentage',
          fri: res.data.data.percentageFri,
          mon: res.data.data.percentageMon,
          sat: res.data.data.percentageSat,
          sun: res.data.data.percentageSun,
          thu: res.data.data.percentageThu,
          total: res.data.data.percentageTotal,
          tue: res.data.data.percentageTue,
          wed: res.data.data.percentageWed
        })
        that.tableData.push({
          left: 'Average Revenue',
          fri: '$' + Utils.formatSplit(res.data.data.avgFri),
          mon: '$' + Utils.formatSplit(res.data.data.avgMon),
          sat: '$' + Utils.formatSplit(res.data.data.avgSat),
          sun: '$' + Utils.formatSplit(res.data.data.avgSun),
          thu: '$' + Utils.formatSplit(res.data.data.avgThu),
          total: '$' + Utils.formatSplit(res.data.data.avgTotal),
          tue: '$' + Utils.formatSplit(res.data.data.avgTue),
          wed: '$' + Utils.formatSplit(res.data.data.avgWed)
        })
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    btmCallback (res) {
      var that = this
      that.loading2 = false
      if(res.data.code == 0){
        this.hasLastWeekData = res.data.data.hasLastWeekData
        var historyList = res.data.data.list
        if (!res.data.data.hasLastWeekData) {
          historyList = Utils.getWeekList(4)
        }
        historyList.forEach(item => {

          item.friIsAvgCost = item.fri.isAvgCost
          item.monIsAvgCost = item.mon.isAvgCost
          item.satIsAvgCost = item.sat.isAvgCost
          item.sunIsAvgCost = item.sun.isAvgCost
          item.thuIsAvgCost = item.thu.isAvgCost
          item.tueIsAvgCost = item.tue.isAvgCost
          item.wedIsAvgCost = item.wed.isAvgCost

          item.total = Utils.formatSplit(item.total)
          item.fri = Utils.formatSplit(item.fri.cost)
          item.mon = Utils.formatSplit(item.mon.cost)
          item.sat = Utils.formatSplit(item.sat.cost)
          item.sun = Utils.formatSplit(item.sun.cost)
          item.thu = Utils.formatSplit(item.thu.cost)
          item.tue = Utils.formatSplit(item.tue.cost)
          item.wed = Utils.formatSplit(item.wed.cost)
        })
        this.tableData2 = historyList
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    pageChange(page) {
      this.page = page
      this.tableData2 = []
      this.loading2 = true
      // 下方表格
      api.history({ params: { page: this.page, size: this.pagesize }, callback: this.btmCallback })
    },
    validate(type) {
      if (type === 'mon') {
        this.tableData3[0].mon = this.tableData3[0].mon.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].mon = '$' + this.tableData3[0].mon
      } else if (type === 'fri') {
        this.tableData3[0].fri = this.tableData3[0].fri.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].fri = '$' + this.tableData3[0].fri
      } else if (type === 'sat') {
        this.tableData3[0].sat = this.tableData3[0].sat.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].sat = '$' + this.tableData3[0].sat
      } else if (type === 'sun') {
        this.tableData3[0].sun = this.tableData3[0].sun.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].sun = '$' + this.tableData3[0].sun
      } else if (type === 'thu') {
        this.tableData3[0].thu = this.tableData3[0].thu.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].thu = '$' + this.tableData3[0].thu
      } else if (type === 'wed') {
        this.tableData3[0].wed = this.tableData3[0].wed.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].wed = '$' + this.tableData3[0].wed
      } else if (type === 'tue') {
        this.tableData3[0].tue = this.tableData3[0].tue.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.tableData3[0].tue = '$' + this.tableData3[0].tue
      }
    },

    closeOrLogoutVenue(isSubscribe) {
      if (isSubscribe) {
        this.isTrialEnd = false
        return
      }
      if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
        this.$root.$emit('logout-venue')
      } else {
        const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
        if (isContUsingTrial == '0') {
          sessionStorage.setItem('isContUsingTrial', '1')
        }
        this.isTrialEnd = false
      }
    }
  },
  components: {
    pageination,
    TreeTable: treeTable,
    freeTrialNotice: freeTrialNotice
  }
}
</script>

<style lang="scss" scoped>
.wrp {
  width: 100%;

  .top-tit {
    font-size: 24px;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 38px;
    font-weight: 600;
  }

  .red {
    color: #EA3796;
  }


  h1 {
    font-size: 20px;
    margin-bottom: 39px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 27px;

    span {
      float: left;
      position: relative;
      cursor: pointer;
      color: #A6A7A9;
      margin-right: 36px;
    }

    .active {
      color: var(--text-color);

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 110%;
        height: 2px;
        background: #EA3796;
      }
    }

    button {
      float: right;
      display: block;
      outline: none;
      background: none;
      cursor: pointer;
      width: 280px;
      height: 60px;
      border: 2px solid #EA3796;
      color: #EA3796;
      margin: 0 auto;
      font-size: 26px;
    }
  }

  .table-wrp {
    margin-bottom: 30px;

    .table-header-title  {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: center;
      .el-tag {
        background-color: rgba(234, 55, 151, 0.1);
        border-color: rgba(234, 55, 151, 0.2);
        color: rgb(234, 55, 149);
      }
    }

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      mask-repeat: no-repeat !important;
      mask-size: 24px 24px !important;
      mask-position: center center !important;
      background-color: var(--text-color);
      mask: url('../../assets/pencil-square.svg');
      -webkit-mask: url('../../assets/pencil-square.svg');
      cursor: pointer;
    }



    .table-head-week {
      h3 {
        //padding: 10px 0 2px 0;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        color: var(--text-color);
        line-height: 19px;
        margin: 0;
      }

      h4 {
        // padding: 0 0 8px 0;
        margin: 0;
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 18px;
      }
    }
  }

  .btns {
    margin: 65px auto 0 auto;
    width: 610px;
  }

  button {
    width: 280px;
    height: 60px;
    outline: none;
    background: none;
    cursor: pointer;
    font-weight: 600;
  }

  .dark {
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 26px;
    float: left;
  }

  .light {
    border: 2px solid #8E3771;
    color: #8E3771;
    font-size: 26px;
    float: right;
  }

  .usable {
    border: 2px solid #EA3796;
    color: #EA3796;
  }

  .pop-wrp {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: var(--background-color-2);
    bottom: 0;
    right: 0;
    z-index: 102;

    .pop-confirm {
      width: 1250px;
      height: 280px;
      background: var(--background-color-4);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;

      .triple {
        text-align: center;

        button {
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          box-sizing: border-box;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }

        button:nth-child(1),
        button:nth-child(2) {
          margin-right: 50px;
        }

        button:nth-child(1) {
          color: var(--text-color);
          border: 2px solid var(--text-color);
        }

        button:nth-child(3),
        button:nth-child(2) {
          color: #D13A90;
          border: 2px solid #D13A90;
        }
      }
    }

    h1 {
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 50px;
      color: var(--text-color);
      text-align: center;
    }

    .btns {
      margin: 65px auto 0 auto;
      width: 610px;

      button {
        width: 280px;
        height: 60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
      }

      .dark {
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
      }

      .light {
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
      }

      .usable {
        border: 2px solid #EA3796;
        color: #EA3796;
      }
    }

    .normal {
      transform: rotate(0deg);
      opacity: 1;
      margin-left: -420px;
    }

    .second-step {
      width: 840px;
      height: 612px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -306px 0 0 -420px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;

      h2 {
        margin-bottom: 30px;
      }

      .upload-con {
        width: 100%;
        height: 280px;
        background: var(--background-color-2);
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        position: relative;
        text-align: center;

        .close {
          width: 20px;
          position: absolute;
          height: 20px;
          right: 28px;
          top: 69px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/c.png');
          cursor: pointer;
        }

        .icon {
          display: block;
          width: 100%;
          height: 35px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-image: url('../../assets/upload.png');
          margin-top: 80px;
          margin-bottom: 30px;
        }

        h3 {
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: var(--text-color);

          span {
            color: #D13A90;
          }
        }

        .upload-demo {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
        }

        .el-icon-loading {
          margin-top: 100px;
          font-size: 30px;
        }

        .file {
          width: 660px;
          height: 120px;
          background: var(--background-color-4);
          position: relative;
          margin: 80px auto 0 auto;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 20px;

          .in {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position: center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
          }

          .text {
            flex: 0 0 auto;
            text-align: left;
            width: 520px;

            .tit {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 24px;
              line-height: 33px;
              margin-bottom: 10px;
              margin-top: 5px;
            }

            .size {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }

    .upload-success {
      width: 410px;
      height: 349px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -176px 0 0 -210px;
      box-sizing: border-box;
      padding: 60px 50px 0 50px;

      i {
        display: block;
        width: 100%;
        height: 60px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        margin-bottom: 40px;
        background-image: url('../../assets/s.png');
      }

      h4 {
        font-size: 24px;
        line-height: 29px;
        margin-bottom: 50px;
        color: var(--text-color);
        text-align: center;
      }

      button {
        width: 100%;
      }
    }

    .lst {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 100%;
        margin: 0;
        padding: 0;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
        color: var(--text-color);
        box-sizing: border-box;
        padding: 0 10px;
        text-align: center;
      }

      .box {
        width: 1250px;
        background: var(--background-color);
        box-sizing: border-box;
        padding: 65px 50px 65px 50px;

        .table-wrp {
          margin-bottom: 15px;
        }

        p {
          font-size: 18px;
          line-height: 25px;
          color: var(--text-color);
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/revenue/index.vue